import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { useLang } from "../i18n";

const BackUs = () => {
  const { t } = useLang();
  return (
    <section id="back" data-testid="back-us-section" className="relative border-t border-white/5 bg-surface/50 py-28 md:py-40">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal testId="back-us-heading" className="text-center">
          <p className="text-gradient mb-6 font-mono text-base uppercase tracking-[0.3em]">
            {t("back.eyebrow", "The Program")}
          </p>
          <h2 className="mx-auto max-w-4xl font-display text-[2rem] font-semibold leading-[1.08] tracking-tight sm:text-[2.75rem]">
            {t("back.h2a", "First, the")} <span className="text-gradient">{t("back.h2b", "equation of immortality.")}</span>{" "}
            {t("back.h2c", "Then, everything it unlocks.")}
          </h2>
        </Reveal>

        <Reveal testId="back-us-card" className="mt-16">
          <div className="mx-auto max-w-4xl rounded-3xl bg-gradient-to-br from-violet-500/40 via-blue-500/15 to-cyan-400/40 p-[1px]">
            <div className="rounded-3xl bg-surface px-8 py-14 text-center md:px-16">
              <span className="inline-flex items-center rounded-full border border-white/15 bg-white/5 px-5 py-2.5 font-mono text-base uppercase tracking-[0.2em] text-white/70">
                {t("back.badge", "Proof before product")}
              </span>
              <div data-testid="back-us-copy">
                <p className="mx-auto mt-8 max-w-2xl text-lg font-light leading-relaxed text-fog">
                  {t(
                    "back.copy",
                    "Our core work is mathematical: a physics-based proof, the equation of immortality, that formalizes why biological time can be arrested and reversed. Every solution we build follows from it."
                  )}
                </p>
              </div>
              <div data-testid="back-us-cta" className="mt-10 flex flex-wrap items-center justify-center gap-4">
                <Link
                  to="/subscribe"
                  data-testid="back-us-invest-button"
                  className="bg-gradient-accent group flex items-center gap-3 rounded-full px-10 py-5 text-base font-semibold text-white shadow-[0_8px_32px_rgba(59,130,246,0.35)] transition-shadow duration-300 hover:shadow-[0_8px_44px_rgba(34,211,238,0.5)]"
                >
                  {t("back.cta1", "Subscribe the Project")}
                  <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </Link>
                <Link
                  to="/back-us"
                  data-testid="back-us-invest-link"
                  className="flex items-center gap-3 rounded-full border border-white/20 px-10 py-5 text-base font-medium text-white transition-colors duration-300 hover:border-cyan-300/50 hover:text-cyan-200"
                >
                  {t("back.cta2", "Back Us")}
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default BackUs;
